/**
 * Public-marketplace host parsing and billing lock helpers.
 * Extracted from Routes.jsx so host → subdomain and delinquent flags
 * can be unit-tested without mounting the full app shell.
 */

export const PRIVATE_APP_SUBDOMAINS = ['app', 'app2', 'old']
export const DEV_HOSTNAMES = ['localhost', 'dev-admin.housefolios.com']
export const SPECIAL_MARKETPLACE_HOSTS = {
  'roitk.com': 'roitk',
  'nlinvesting.com': 'nlinvesting',
}

export function resolveMarketplaceSubdomain({
  host,
  search = '',
  envHostname,
} = {}) {
  const hostname = host || ''
  let subdomain = hostname.split('.')[1]
    ? hostname.split('.')[0]
    : null

  if (DEV_HOSTNAMES.includes(envHostname)) {
    const params = new URLSearchParams(
      String(search).startsWith('?') ? String(search).slice(1) : search,
    )
    subdomain = params.get('subdomain')
  } else if (SPECIAL_MARKETPLACE_HOSTS[hostname]) {
    subdomain = SPECIAL_MARKETPLACE_HOSTS[hostname]
  } else if (PRIVATE_APP_SUBDOMAINS.includes(subdomain)) {
    subdomain = null
  }

  return subdomain
}

/** Any truthy Organization.delinquent value (including fallback last4 '44444') locks the app. */
export function isDelinquentOrg(activeOrg) {
  return Boolean(activeOrg?.delinquent)
}
